import { render, staticRenderFns } from "./MortalityCausesGraph.vue?vue&type=template&id=fd72d65e&"
import script from "./MortalityCausesGraph.vue?vue&type=script&lang=js&"
export * from "./MortalityCausesGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports